import _Object$freeze from "core-js/library/fn/object/freeze.js";
import _Object$defineProperties from "core-js/library/fn/object/define-properties.js";
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), _Object$freeze(_Object$defineProperties(e, {
    raw: {
      value: _Object$freeze(t)
    }
  }));
}
export { _taggedTemplateLiteral as default };